import Swiper from 'swiper';

const matcher = window.matchMedia(`(pointer: fine)`);

Swiper.extendDefaults({
  preventClicks: false,
  preventClicksPropagation: false,
  // when using mouse require swipes to be at least 100ms and 20% of the slide
  ...(matcher.matches && {
    longSwipesMs: 100,
    longSwipesRatio: 0.2,
    shortSwipes: false,
  }),
});

// https://github.com/nolimits4web/swiper/blob/d68a71bea14361010ef201b15359ed6a64c37f4c/src/core/core.js#L91-L98
const BetterClickHandler = ({ swiper, on, emit }) => {
  let allowClick = false;

  const onClick = (e) => {
    if (allowClick) {
      emit('ppClick', e);
    } else {
      e.preventDefault();

      // https://github.com/nolimits4web/swiper/blob/d68a71bea14361010ef201b15359ed6a64c37f4c/src/core/events/onClick.js
      if (swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  };

  const onTouchStart = () => {
    allowClick = false;
  };

  const onTouchEnd = () => {
    const { touchEventsData: data } = swiper;
    const touchEndTime = Date.now();
    const timeDiff = touchEndTime - data.touchStartTime;
    const moveDiff = data.isMoved
      ? Math.abs(data.currentTranslate - data.startTranslate)
      : 0;
    // console.log(`touch end details ${timeDiff} ${moveDiff}`);
    allowClick = timeDiff < 200 && moveDiff < 5;
  };

  const onInit = () => {
    swiper.el.addEventListener('click', onClick);
  };

  const onDestroy = () => {
    swiper.el.removeEventListener('click', onClick);
  };

  on('init', onInit);
  on('destroy', onDestroy);
  on('touchStart', onTouchStart);
  on('touchEnd', onTouchEnd);
};

Swiper.use(BetterClickHandler);
